/* prettier-ignore */

export const statesMock = [
  {
    "id": 1,
    "description": "Acre",
    "acronym": "AC"
  },
  {
    "id": 2,
    "description": "Alagoas",
    "acronym": "AL"
  },
  {
    "id": 4,
    "description": "Amapá",
    "acronym": "AP"
  },
  {
    "id": 3,
    "description": "Amazonas",
    "acronym": "AM"
  },
  {
    "id": 5,
    "description": "Bahia",
    "acronym": "BA"
  },
  {
    "id": 6,
    "description": "Ceará",
    "acronym": "CE"
  },
  {
    "id": 7,
    "description": "Distrito Federal",
    "acronym": "DF"
  },
  {
    "id": 8,
    "description": "Espírito Santo",
    "acronym": "ES"
  },
  {
    "id": 9,
    "description": "Goiás",
    "acronym": "GO"
  },
  {
    "id": 10,
    "description": "Maranhão",
    "acronym": "MA"
  },
  {
    "id": 13,
    "description": "Mato Grosso",
    "acronym": "MT"
  },
  {
    "id": 12,
    "description": "Mato Grosso do Sul",
    "acronym": "MS"
  },
  {
    "id": 11,
    "description": "Minas Gerais",
    "acronym": "MG"
  },
  {
    "id": 18,
    "description": "Paraná",
    "acronym": "PR"
  },
  {
    "id": 15,
    "description": "Paraíba",
    "acronym": "PB"
  },
  {
    "id": 14,
    "description": "Pará",
    "acronym": "PA"
  },
  {
    "id": 16,
    "description": "Pernambuco",
    "acronym": "PE"
  },
  {
    "id": 17,
    "description": "Piauí",
    "acronym": "PI"
  },
  {
    "id": 20,
    "description": "Rio Grande do Norte",
    "acronym": "RN"
  },
  {
    "id": 23,
    "description": "Rio Grande do Sul",
    "acronym": "RS"
  },
  {
    "id": 19,
    "description": "Rio de Janeiro",
    "acronym": "RJ"
  },
  {
    "id": 21,
    "description": "Rondônia",
    "acronym": "RO"
  },
  {
    "id": 22,
    "description": "Roraima",
    "acronym": "RR"
  },
  {
    "id": 24,
    "description": "Santa Catarina",
    "acronym": "SC"
  },
  {
    "id": 25,
    "description": "Sergipe",
    "acronym": "SE"
  },
  {
    "id": 26,
    "description": "São Paulo",
    "acronym": "SP"
  },
  {
    "id": 27,
    "description": "Tocantins",
    "acronym": "TO"
  }
]
